export const getUnconfirmedEmail = (state) => state.entities.users.unconfirmedEmail;
